<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      app
      clipped>

      <v-list dense>

        <v-list-item link to="/home">
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/plan">
          <v-list-item-action>
            <v-icon>mdi-ballot-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Planos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/client">
          <v-list-item-action>
            <v-icon>mdi-account-box-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Clientes</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/internet">
          <v-list-item-action>
            <v-icon>mdi-wan</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Internet</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/lastmile">
          <v-list-item-action>
            <v-icon>mdi-download-network</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Lastmile</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/lan2lan">
          <v-list-item-action>
            <v-icon>mdi-lan</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Lan2Lan</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/ferramentas" v-if="$auth.isSubusername('suporte') || !$auth.isSubuser()">
          <v-list-item-action>
            <v-icon>mdi-tools</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Ferramentas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/fatura/internet" v-show="false">
          <v-list-item-action>
            <v-icon>mdi-currency-usd</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Faturas - Internet</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list>
      
    </v-navigation-drawer>

    <v-app-bar app clipped-left dark  v-if="$auth.check('ROLE_ADMIN')">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Netter</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-chip class="ma-2" color="default"><v-avatar left color="secondary"><v-icon>mdi-account</v-icon></v-avatar>{{ $auth.user().username }}</v-chip>
      <v-btn icon large @click="logout()">
        <v-icon>mdi-exit-run</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>

    <v-footer app>
      <span>&copy; 2025</span>
    </v-footer>
    
  </v-app>
</template>

<script>
import router from "./router/index.js";
export default {
  data: () => ({
    drawer: false
  }),
  created: function() {
    var me = this;
    this.$auth.remember()
      .then(function() {
        if(me.$auth.check("ROLE_ADMIN")){
          me.drawer = true;
        }else{
          me.logout();
        }
      })
      .catch(function() {
        me.logout();
      });
  },
  methods: {
    logout: function() {
      this.$auth.logout();
      this.drawer = false;
      router.push("/login");
    }
  }
};
</script>

<style>
h1 {
  font-weight: 300;
}
</style>